import JSONModel from "sap/ui/model/json/JSONModel";
import Dialog from "sap/m/Dialog";
import BaseTypedController from "ips/ac/base/controller/BaseTypedController";
import ProjectGeneratorModuleInterface from "ips/ac/data/client/model/ProjectGeneratorModuleInterface";
import ODataListBinding from "sap/ui/model/odata/v4/ODataListBinding";
import FilterOperator from "sap/ui/model/FilterOperator";
import Filter from "sap/ui/model/Filter";
import { UserView } from "ips/ac/model/api/WinDoFlow.api.types";
import Select from "sap/m/Select";
import HttpUtil from "ips/ac/util/HttpUtil";
import Util from "ips/ac/util/Util";

/**
 * @namespace ips.ac.data.client.controller
 * */
export default class ProjectGeneratorModuleDialogController extends BaseTypedController {
  private dialog: Dialog;
  private dialogModel: JSONModel;
  private listBinding: ODataListBinding;
  private userSelect: Select;
  private isUpdated: boolean = false;
  // @ts-ignore
  private closeCallBack: ({ "isUpdated": boolean }) => void;

  onInit(): void {
    super.onInit();
    this.dialogModel = new JSONModel();
    this.userSelect = this.getView().byId("userSelect") as Select;
    this.getView().setModel(this.dialogModel, "dialog");
    this.dialog = this.getView().byId("projectGeneratorModuleDialog") as Dialog;
  }

  public async openDialog(data: ProjectGeneratorModuleInterface, closeCallBack: () => void): Promise<void> {
    this.closeCallBack = closeCallBack;
    this.isUpdated = false;
    this.dialogModel.setProperty("/payload", data);
    this.dialog.open();
    this.dialog.setBusy(true);
    await this.loadUsers(data.clientGuid);
    this.dialog.setBusy(false);
  }

  public async loadUsers(clientGuid: string): Promise<void> {
    if (this.listBinding) {
      this.listBinding.destroy();
    }
    const filter = new Filter([
      new Filter("IsActive", FilterOperator.EQ, 1),
      new Filter("ClientGuid", FilterOperator.EQ, clientGuid),
    ], true);

    this.listBinding = this.getModel().bindList("/Users", undefined, undefined, filter) as ODataListBinding;
    const contexts = await this.listBinding.requestContexts(0, Infinity);
    const users: UserView[] = contexts.map((context) => context.getObject());
    this.dialogModel.setProperty("/users", users);

  }

  async onSave() {
    const data = this.dialogModel.getProperty("/payload");
    const serviceUrl = Util.getIpsConfig().getProperty("/RestApi") + "/client/partner/setGeneratorModule";
    this.dialog.setBusy(true);
    try {
      await HttpUtil.post(serviceUrl, null, data);
      this.isUpdated = true;

    } finally {
      this.dialog.setBusy(false);

    }

    this.closeDialog();

  }

  async onAfterCloseDialog() {
    this.closeCallBack({ isUpdated: this.isUpdated });
  }

  closeDialog() {
    this.dialog.close();
  }


}